export default {
  title: 'Buchungsbenachrichtigungen',
  label: 'Wohin sollen wir Benachrichtigungen über Reservierungen senden?',
  placeholder: 'z. B. reservierung@ihrrestaurant.de',
  helper:
    'Jede E-Mail-Adresse funktioniert – sie braucht keinen Dashboard-Zugang. Sie können sie später unter Reservierungen → Einstellungen → Benachrichtigungen & Bestätigung ändern oder weitere hinzufügen.',
  errors: {
    required: 'Geben Sie eine E-Mail-Adresse an, damit Sie Buchungsbenachrichtigungen erhalten.',
    invalid: 'Geben Sie eine gültige E-Mail-Adresse ein, z. B. name@restaurant.de.',
  },
};
